import React, {useState} from 'react'
import { Steps, Button, Tooltip, Spin, Row, Typography, DatePicker, Switch, Col, Card, Modal, Form, Input, Radio, Checkbox, Select, Icon, Divider } from 'antd';
import warningAlert from '../Membership/warning-alert.png'

export default function CustomPopupModal(props) {

    const {doesShowPopup, closePopup, popupTitle, popupPrimaryContent, popupSecondaryContent,
    closable = true, btnText = 'CLOSE'
    } = props;
    
  return  <Modal
    className='custom-model'
    title={false}
    footer={false}
    visible={doesShowPopup}
    centered
    closable={closable}
    onCancel={() => closePopup()}
>
    <div className="center">
        <div>
            <img src={warningAlert} width="40px" height="40px" />
        </div>
        <div className='No-Results-Match-Pro'>
            {popupTitle ? popupTitle : ''}
        </div>

        {popupPrimaryContent}
        {popupSecondaryContent}

        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                <div className='step-container margin-top-20' >
                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                        closePopup();
                    }} htmlType='submit'>{btnText} </Button>
                </div>
            </Col>
        </Row>
    </div>
</Modal>
}



// WEBPACK FOOTER //
// ./src/components/Inc/customPopupModal.js